(function () {
  const root = document.querySelector("[data-customer-documents]");
  if (!root) return;

  const apiBase = root.dataset.apiBase || "/apps/customer-portal";
  const detailType = root.dataset.detailType || "";
  const detailId = root.dataset.detailId || "";

  const loadingEl = root.querySelector("[data-documents-loading]");
  const errorEl = root.querySelector("[data-documents-error]");
  const errorMessageEl = root.querySelector("[data-documents-error-message]");
  const listViewEl = root.querySelector("[data-documents-list-view]");
  const detailViewEl = root.querySelector("[data-documents-detail-view]");

  const cardTemplate = root.querySelector("[data-document-card-template]");
  const lineTemplate = root.querySelector("[data-document-line-template]");

  const state = {
    loadedBlocks: {
      orders: false,
      invoices: false,
      quotes: false,
    },
  };

  function setLoading(visible) {
    loadingEl.classList.toggle("hidden", !visible);
  }

  function showError(message) {
    setLoading(false);
    errorMessageEl.textContent = message || "Error desconocido.";
    errorEl.classList.remove("hidden");
    listViewEl.classList.add("hidden");
    detailViewEl.classList.add("hidden");
  }

  function hideError() {
    errorEl.classList.add("hidden");
  }

  function formatMoney(value, currency) {
    const amount = Number(value || 0);
    return new Intl.NumberFormat("es-ES", {
      style: "currency",
      currency: currency || "EUR",
    }).format(amount);
  }

  function formatDate(value) {
    if (!value) return "";
    const date = new Date(value);
    return new Intl.DateTimeFormat("es-ES", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).format(date);
  }

  function lineCountLabel(lines) {
    const count = Array.isArray(lines) ? lines.length : 0;
    return count === 1 ? "1 artículo" : `${count} artículos`;
  }

  function getTypeLabel(type) {
    if (type === "orders") return "Pedidos";
    if (type === "invoices") return "Facturas";
    return "Presupuestos";
  }

  async function apiGet(path) {
    const response = await fetch(`${apiBase}${path}`, {
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      let message = `Error ${response.status}`;
      try {
        const data = await response.json();
        if (data && data.error) message = data.error;
      } catch (_) {}
      throw new Error(message);
    }

    return response.json();
  }

  function buildDetailHref(type, id) {
    const url = new URL(window.location.href);
    url.searchParams.set("document_type", type);
    url.searchParams.set("document_id", id);
    return url.toString();
  }

  function renderCards(type, documents) {
    const container = root.querySelector(`[data-block-cards="${type}"]`);
    container.innerHTML = "";

    documents.forEach((doc) => {
      const fragment = cardTemplate.content.cloneNode(true);
      const article = fragment.querySelector(".customer-document-card");

      fragment.querySelector(".customer-document-card__number").textContent = `#${doc.number}`;
      fragment.querySelector(".customer-document-card__secondary").textContent = lineCountLabel(doc.lines);
      fragment.querySelector(".customer-document-card__status").textContent = doc.statusLabel || doc.status || "-";
      fragment.querySelector(".customer-document-card__date").textContent = formatDate(doc.date);
      fragment.querySelector(".customer-document-card__amount").textContent = formatMoney(doc.total, doc.currency);

      const detailLink = fragment.querySelector(".customer-document-card__link");
      detailLink.href = buildDetailHref(type, doc.id);

      container.appendChild(fragment);
    });
  }

  function renderAddress(container, address) {
    if (!address) {
      container.innerHTML = "<p>-</p>";
      return;
    }

    const parts = [
      address.name,
      address.street,
      [address.postalCode, address.city].filter(Boolean).join(" "),
      address.region,
      address.country,
      address.email,
      address.phone,
    ].filter(Boolean);

    container.innerHTML = parts.map((part) => `<p>${escapeHtml(part)}</p>`).join("");
  }

  function renderContact(container, detail) {
    const parts = [
      detail.customerName,
      detail.customerEmail,
      detail.customerPhone,
    ].filter(Boolean);

    container.innerHTML = parts.map((part) => `<p>${escapeHtml(part)}</p>`).join("");
  }

  function renderLines(lines) {
    const container = root.querySelector("[data-detail-lines]");
    container.innerHTML = "";

    (lines || []).forEach((line) => {
      const fragment = lineTemplate.content.cloneNode(true);
      fragment.querySelector(".customer-document-line__qty").textContent = line.quantity || 0;
      fragment.querySelector(".customer-document-line__info").textContent = `${line.sku || "-"} - ${line.description || "-"}`;
      fragment.querySelector(".customer-document-line__price").textContent = formatMoney(line.total, line.currency || "EUR");
      container.appendChild(fragment);
    });
  }

  function fillDetail(detail) {
    root.querySelector("[data-detail-type-label]").textContent = getTypeLabel(detail.type);
    root.querySelector("[data-detail-title]").textContent = `${detail.typeLabelSingular || "Documento"} #${detail.number}`;
    root.querySelector("[data-detail-date]").textContent = `Fecha de confirmación: ${formatDate(detail.date)}`;
    root.querySelector("[data-detail-status]").textContent = detail.statusLabel || detail.status || "-";
    root.querySelector("[data-detail-doc-date]").textContent = formatDate(detail.date);
    root.querySelector("[data-detail-payment-status]").textContent = detail.paymentStatusLabel || "Procesado";
    root.querySelector("[data-detail-payment-method]").textContent = detail.paymentMethod || "-";

    renderContact(root.querySelector("[data-detail-contact]"), detail);
    renderAddress(root.querySelector("[data-detail-billing]"), detail.billingAddress);
    renderAddress(root.querySelector("[data-detail-shipping]"), detail.shippingAddress);
    renderLines(detail.lines);

    root.querySelector("[data-detail-subtotal]").textContent = formatMoney(detail.subtotal, detail.currency);
    root.querySelector("[data-detail-shipping-cost]").textContent = formatMoney(detail.shippingTotal, detail.currency);
    root.querySelector("[data-detail-total]").textContent = formatMoney(detail.total, detail.currency);
    root.querySelector("[data-detail-tax]").textContent = `Incluye ${formatMoney(detail.taxTotal, detail.currency)} de impuestos`;

    const pdfLink = root.querySelector("[data-detail-pdf]");
    if (detail.pdfUrl) {
      pdfLink.href = detail.pdfUrl;
      pdfLink.classList.remove("hidden");
    } else {
      pdfLink.href = `${apiBase}/documents/${detail.type}/${detail.id}/pdf`;
      pdfLink.classList.remove("hidden");
    }
  }

  async function loadBlock(type) {
    if (state.loadedBlocks[type]) return;

    const data = await apiGet(`/documents?type=${encodeURIComponent(type)}&limit=5`);
    renderCards(type, data.documents || []);
    state.loadedBlocks[type] = true;
  }

  async function loadDetail(type, id) {
    const data = await apiGet(`/documents/${encodeURIComponent(type)}/${encodeURIComponent(id)}`);
    fillDetail(data.document);
  }

  async function initListView() {
    hideError();
    setLoading(false);
    listViewEl.classList.remove("hidden");
    detailViewEl.classList.add("hidden");

    root.querySelectorAll("[data-toggle-block]").forEach((button) => {
      button.addEventListener("click", async function () {
        const type = button.dataset.toggleBlock;
        const body = root.querySelector(`[data-block-body="${type}"]`);
        const arrow = button.querySelector(".customer-documents__section-arrow");
        const isHidden = body.classList.contains("hidden");

        if (isHidden) {
          try {
            await loadBlock(type);
            body.classList.remove("hidden");
            arrow.textContent = "−";
          } catch (error) {
            showError(error.message);
          }
        } else {
          body.classList.add("hidden");
          arrow.textContent = "+";
        }
      });
    });
  }

  async function initDetailView() {
    hideError();
    setLoading(true);
    listViewEl.classList.add("hidden");
    detailViewEl.classList.remove("hidden");

    try {
      await loadDetail(detailType, detailId);
      setLoading(false);
    } catch (error) {
      showError(error.message);
    }
  }

  function escapeHtml(value) {
    return String(value)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  if (detailType && detailId) {
    initDetailView();
  } else {
    initListView();
  }
})();
